import { createAppUrl } from 'utils/url/createAppUrl';
import { hasParams } from 'utils/url/createAppUrl/utils/hasParams';
/**
 * Creates the `to` string for the app links.
 *
 * @param options The props.
 */
export function createTo(options) {
    return hasParams(options)
        ? createAppUrl({ path: options.path, params: options.params })
        : createAppUrl({ path: options.path });
}
